export interface Statistics {
  timestamp?: number;
  domain?: string;
  accountId?: string;
  sendingId?: string;
  activityId?: string;
  type?: string;
  countryCode?: string;
  sent: number;
  delivered: number;
  normalizedDelivered: number;
  deliveryRate: number;
  open: number;
  uniqueOpen: number;
  openRate: number;
  click: number;
  uniqueClick: number;
  clickRate: number;
  clickToOpenRate: number;
  bounce: number;
  uniqueBounce: number;
  bounceRate: number;
  unsubscribe: number;
  uniqueUnsubscribe: number;
  unsubscribeRate: number;
  abuse: number;
  uniqueAbuse: number;
  abuseRate: number;
}

export const makeStatistics = (
  values: Partial<Statistics> = {},
): Statistics => ({
  sent: 0,
  delivered: 0,
  normalizedDelivered: 0,
  deliveryRate: 0,
  open: 0,
  uniqueOpen: 0,
  openRate: 0,
  click: 0,
  uniqueClick: 0,
  clickRate: 0,
  clickToOpenRate: 0,
  bounce: 0,
  uniqueBounce: 0,
  bounceRate: 0,
  unsubscribe: 0,
  uniqueUnsubscribe: 0,
  unsubscribeRate: 0,
  abuse: 0,
  uniqueAbuse: 0,
  abuseRate: 0,
  ...values,
});
